import { ChangeDetectionStrategy, Component, inject, output, signal } from '@angular/core';
import { NotificationService } from '../../../core/services/notification.service';
import type { Notification } from '../../../core/models/notification.model';
import { ClickOutsideDirective } from '../../directives/click-outside.directive';
import { NotificationPanelComponent } from '../../ui/notification-panel/notification-panel.component';
import { LogoMarkComponent } from '../../ui/logo-mark/logo-mark.component';

// Reemplaza `renderHeader()` de _nav.js. Toma esa versión (no las inline ligeramente distintas
// de dashboard.html/mensajes.html) como fuente de verdad — es justo la duplicación que
// parte_10 §6 pide eliminar.
@Component({
  selector: 'app-header',
  standalone: true,
  imports: [ClickOutsideDirective, NotificationPanelComponent, LogoMarkComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './header.component.html',
})
export class HeaderComponent {
  private readonly notificationService = inject(NotificationService);

  readonly menuToggle = output<void>();

  readonly notifications = this.notificationService.notifications;
  readonly unreadCount = this.notificationService.unreadCount;

  readonly isNotifOpen = signal(false);

  toggleNotifPanel(): void {
    this.isNotifOpen.update((open) => !open);
  }

  closeNotifPanel(): void {
    this.isNotifOpen.set(false);
  }

  onNotificationClick(notification: Notification): void {
    this.notificationService.markAsRead(notification.id);
    this.closeNotifPanel();
  }
}
